import {ismobile} from './utils'
import { gsap } from "gsap";

let next = 1;			// fixed, please do not modfy;
let current = 0;		// fixed, please do not modfy;
let interval = 500;	// You can senpm run devt single picture show time;
let fadeTime = 800;	// You can set fadeing-transition time;
let imgNum = 8;		// How many pictures do you

function imageFade(){
  // if (!ismobile()){
    nextFadeIn();
  // }
}

function nextFadeIn() {   

    //make image fade in and fade out at one time, without splash vsual;
    $('.header__fade img').eq(current).delay(interval).fadeOut(fadeTime)
    .end().eq(next).delay(interval).hide().fadeIn(fadeTime, nextFadeIn);

    // if You have 5 images, then (eq) range is 0~4 
    // so we should reset to 0 when value > 4; 
    if(next < imgNum-1){ 
        next++; 
    } else { 
        next = 0;
    }
    if(current < imgNum-1){ 
        current++; 
    } else { 
        current =0; 
    }

}

export default imageFade;